import { useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../../../components/molecules/footer/Footer";
import Header from "../../../components/molecules/header/Header";
import { useEffect, useState } from "react";
import { getJustificacionActoPresentado } from "../../../components/services/DatoPersonalService";
import { SpinnerCircle } from "../../../components/atoms/spinner/Spinner";
//import { SpinnerCircle } from "../../../components/atoms/spinner/Spinner";


const JustificacionActoPresentado = () => {
  const navigate = useNavigate();
  const params = useParams();
  // const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [solicitud, setSolicitud] = useState("");
  const { state } = useLocation()

  
  
  

  useEffect(() => {
    setLoading(true)
    getJustificacionActoPresentado(params?.xsolactadm,state?.tipoActo).then((data) => {
     // Si viene blob vacío
      if (data instanceof Blob && data.size === 0) {
        setSolicitud("");
        setLoading(false); 
        return}

       // Si viene error o null/undefined
      if (!data || (typeof data === "string" && data.toString().startsWith("Error"))) {
        setSolicitud("");
        setLoading(false);
        return;
      }
      
      // OK: leer PDF
     
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = function () {
          var base64data = reader.result;
          setSolicitud(base64data);
          setLoading(false);  
        };
         // Si falla FileReader, cortamos spinner
        reader.onerror = function () {
          setSolicitud("");
          setLoading(false);
        };     
    });
  }, [params?.xsolactadm,state?.tipoActo]);
  return (<>
    <Header />
    <div className="container-fluid" role="main" data-landmark-index="4">
      <div className="datosPersonalesCarrera d-flex flex-column m-2">
        <div>
          <div className="d-flex justify-content-between">
            {/* <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold"}
              tipo={"tituloCard noBg"}
              titulo={`Resolución - ${state?.nombre}`}
            ></Titulo> */}
            <div className="subSubTituloSolicitud p-2 fw-bold">
              <h2 className="tituloCard noBg fs-6">{`Resolución${state?.nombre ? ` - ${state.nombre}` : ""}`}</h2>
            </div>
          </div>
          <div className="separador"></div>
        </div>
        {/* //{loading? (<><SpinnerCircle/></>): (<> */}

        <div className="formulario">
          <>
            <div className="m-2"></div>
            {loading ? (<><SpinnerCircle /></>) : (<>
              <div className="m-3 card scroll-list container-list-border">
                <div className="gridPresentar">
                  <div className="iframePresentar pt-3">
                    {solicitud ? (
                      <object
                        data={solicitud}
                        type="application/pdf"
                        height="500"
                        width="100%"
                        aria-label="PDF del borrador"
                        className="rounded"
                        name="sol"
                      />
                    ) : (
                      <p style={{ height: "500px", width: "100%" }}>
                        No se ha encontrado el documento en el
                        sistema.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>)}

          </>
          <div className="gridBotones mb-2">
            <button
              id="volver"
              className="btnRed rounded btnCancelarDocumentacion"
              type="button"
              title ="Volver"
              aria-label="Volver a la selección de solicitudes"
              onClick={() => {
                if (state?.tipoActo ==="z9") {
                  navigate("/reconNivelCarrera", {state: {accesoPDF: true}})
                }else if (state?.tipoActo ==="s1") {
                  navigate("/variacionDatosPersonales", {state: {accesoPDF: true}})}
                }
                
              }
            >
              <i className="fa-solid fa-rotate-left"></i> Volver
            </button>
          </div>
        </div>
        {/* /*</div></>)} */}

      </div>
    </div>
    <Footer />
  </>)
}

export default JustificacionActoPresentado;